export default {"src":"/_next/static/image/public/remove.0206cf8837b0c77dd45804332be18554.svg","height":34,"width":34};